import { DdpVideo } from "@/components/shared/DdpVideo";
import { TDdpMedia } from "@/shared/types";

export function SixthSection(props: Array<{
    title: string
    description: string
    video: Array<TDdpMedia>
}>) {
    const { title, description, video } = props[0];
    return (
        <div className="landing-sixth-section">
            <div className="title">{title}</div>
            <div className="description" dangerouslySetInnerHTML={{ __html: description }} />
            {video && video[0] && <DdpVideo className="video" video={video[0]} lazyLoad loop hasButton />}
        </div>
    );
}